
import { defineComponent } from 'vue';
import HeaderLogo from '../components/Layout/HeaderLogo.vue';
import ResponsiveContainer from '../components/Layout/ResponsiveContainer.vue';
import { AvailableLoan } from '@/interfaces/loan';
import LoanItem from '@/components/MultiLoan/LoanItem.vue';
import { clearStorage } from '@/storage';

export default defineComponent({
  name: 'SelectLoan',

  components: { ResponsiveContainer, HeaderLogo, LoanItem },

  computed: {
    availableLoans(): AvailableLoan[] {
      return this.$store.getters['User/availableLoans'];
    },
  },

  methods: {
    setActiveLoan(loan: AvailableLoan) {
      this.$store.dispatch('User/setActiveLoan', loan.loan_number);
      this.$router.push({ name: 'home' });
    },

    logout() {
      clearStorage();
      window.location.reload();
    }
  }
});
